import * as Yup from 'yup';

export const createFaqSchema = Yup.object().shape({
  question: Yup.object().shape({
    uz: Yup.string().required('Savol (uz) majburiy'),
    ru: Yup.string().required('Savol (ru) majburiy'),
    en: Yup.string().required('Savol (en) majburiy'),
  }),
  answer: Yup.object().shape({
    uz: Yup.string().required('Javob (uz) majburiy'),
    ru: Yup.string().required('Javob (ru) majburiy'),
    en: Yup.string().required('Javob (en) majburiy'),
  }),
});